import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import moment from 'moment'
import { StoreExt } from '@utils/reactExt'

import { statistics } from '@services/api'

export class statisticsStore extends StoreExt {
    @observable loading = false
    @observable filters = {}
    @observable users = 0
    @observable missings = 0
    @observable duplicates = 0

    @action
    getStatistics = async () => {
        this.loading = true
        const { users, missings, duplicates } = (await statistics.getStatistics({ ...this.filters })).data
        runInAction(() => {
            this.users = users
            this.missings = missings
            this.duplicates = duplicates
            this.loading = false
        })
    }
    @action
    addFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = newFilters
        })
    }

    @action
    resetFilters = () => {
        this.filters = {}
    }
}

export default remotedev(new statisticsStore())
